import React, { FC } from "react";
import { Link } from "react-router-dom";

// const stepperData = ["Basic information", "Insurance selection"];
const stepperData = [
  { name: "Basic information", link: "/" },
  { name: "Insurance offers", link: "/offers" },
];

const Stepper: FC<{
  step: number;
}> = (props) => {
  const stepIsActive = (activeStep: number) => {
    if (activeStep < props.step - 1) {
      return "--completed";
    } else if (activeStep === props.step - 1) {
      return "--active";
    } else if (activeStep > props.step - 1) {
      return "";
    }
  };

  return (
    <div className="stepper">
      <div className="container">
        {stepperData.map((stepper, index) => (
          <div className={`step step${stepIsActive(index)}`} key={index}>
            {index <= props.step - 1 ? (
              <Link to={stepper.link}>
                <span className=" step__number text--primary">
                  {index < props.step - 1 ? "\u2713" : index + 1}
                </span>
              </Link>
            ) : (
              <span className=" step__number text--primary">
                {index < props.step - 1 ? "\u2713" : index + 1}
              </span>
            )}
            {index <= props.step - 1 ? (
              <Link to={stepper.link}>
                <span className="step__text text--secondary">
                  {stepper.name}
                </span>
              </Link>
            ) : (
              <span className="step__text text--secondary">{stepper.name}</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Stepper;
